import { BackToTop } from './BackToTop';
import { Chatbot } from './Chatbot';
import { FloatingButton as InternalFloatingButton } from './FloatingButton';
import { Group } from './Group';

export const FloatingButton =
  InternalFloatingButton as typeof InternalFloatingButton & {
    Group: typeof Group;
    BackToTop: typeof BackToTop;
    Chatbot: typeof Chatbot;
  };

FloatingButton.Group = Group;
FloatingButton.BackToTop = BackToTop;
FloatingButton.Chatbot = Chatbot;
